import * as React from "react";
import { cn } from "@/core/utils/utils";

export interface SimpleInputProps extends React.ComponentProps<"input"> {
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
}

const SimpleInput = React.forwardRef<HTMLInputElement, SimpleInputProps>(
  ({ className, type, startAdornment, endAdornment, ...props }, ref) => (
    <div className="relative">
      {startAdornment && (
        <div className="absolute left-4 top-1/2 -translate-y-1/2 text-secondary-text">
          {startAdornment}
        </div>
      )}
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-lg border border-input bg-transparent px-3 py-1 text-md shadow-sm transition-colors",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-lg placeholder:leading-6 placeholder:text-tertiary-text",
          "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "md:text-lg",
          startAdornment && "pl-11",
          endAdornment && "pr-11",
          className,
        )}
        ref={ref}
        {...props}
      />
      {endAdornment && (
        <div className="absolute right-4 top-1/2 -translate-y-1/2 text-secondary-text">
          {endAdornment}
        </div>
      )}
    </div>
  ),
);

SimpleInput.displayName = "SimpleInput";

export { SimpleInput };
